export default __webpack_public_path__ + "static/media/InfoIcons.3ed931ed.png";